import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight, Star, Zap, ShieldCheck, Download } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-12 pb-10 md:pt-32 md:pb-24 overflow-hidden" data-id="element-129">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 opacity-30 pointer-events-none" data-id="element-130">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-[#D4A5A5] blur-[100px]" data-id="element-131" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[400px] h-[400px] rounded-full bg-[#B8C9C0] blur-[80px]" data-id="element-132" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-133">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-134">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center lg:text-left" data-id="element-135">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#FAF0E6] border border-[#EAE0D5] mb-4" data-id="element-136">
              <Star className="w-3 h-3 text-[#C17B5C] fill-current" data-id="element-137" />
              <span className="text-xs font-medium text-[#8B7355] tracking-wide uppercase" data-id="element-138">
                Edición 2026
              </span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 text-[#3D2B1F]" data-id="element-139">
              La Biblioteca Total de{' '}
              <span className="text-[#C17B5C] italic" data-id="element-140">Crochet</span>
            </h1>

            {/* Promise statement */}
            <div className="mb-6 max-w-xl mx-auto lg:mx-0" data-id="element-141">
              <p className="text-lg md:text-2xl font-semibold text-[#3D2B1F] leading-snug" data-id="element-142">
                Encontrá tu próximo patrón perfecto{' '}
                <span className="text-[#C17B5C]" data-id="element-143">en menos de 60 segundos</span>
              </p>
              <p className="text-sm md:text-base text-[#6B5A4E] mt-2 leading-relaxed" data-id="element-144">
                con más de{' '}
                <span className="font-bold text-[#3D2B1F]" data-id="element-145">4.500 opciones</span>{' '}
                ordenadas por nivel, prenda y tiempo
              </p>
            </div>

            <p className="text-base md:text-xl text-[#6B5A4E] mb-6 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-146"></p>

            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start" data-id="element-147">
              <a href="#producto" onClick={e => {
              e.preventDefault();
              document.getElementById('producto')?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }} data-id="element-148">
                <Button size="lg" className="group" data-id="element-149">
                  Obtener Acceso Ahora
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-150" />
                </Button>
              </a>
            </div>

            <div className="mt-5 flex items-center justify-center lg:justify-start gap-6 text-sm text-[#8B7355]" data-id="element-151">
              <div className="flex items-center gap-1.5" data-id="element-152">
                <Zap className="w-4 h-4 text-[#C17B5C]" data-id="element-153" />
                <span data-id="element-154">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-155">
                <Download className="w-4 h-4 text-[#C17B5C]" data-id="element-156" />
                <span data-id="element-157">Descarga al instante</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-158">
                <ShieldCheck className="w-4 h-4 text-[#C17B5C]" data-id="element-159" />
                <span data-id="element-160">Pago seguro</span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 50
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-161">
            <div className="relative rounded-[2rem] overflow-hidden shadow-2xl border-8 border-white" data-id="element-162">
              <img src="https://cdn.magicpatterns.com/uploads/3NDuZgW4TQYyMLE6pVEtQs/LibroDigital_(2).jpg" alt="Biblia Crochet 2026 - Libro Digital" className="w-full h-auto object-contain" loading="eager" decoding="async" fetchPriority="high" data-id="element-163" />
            </div>
            {/* Floating badge */}
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            repeat: Infinity,
            duration: 4,
            ease: 'easeInOut'
          }} className="absolute -bottom-6 -left-6 md:bottom-10 md:-left-10 bg-white p-4 rounded-xl shadow-xl border border-[#EAE0D5] max-w-[200px]" data-id="element-164">
              <div className="flex items-center gap-3 mb-2" data-id="element-165">
                <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-166" />
                <span className="text-xs font-bold text-[#3D2B1F] uppercase tracking-wider" data-id="element-167">
                  Disponible
                </span>
              </div>
              <p className="text-sm font-serif italic text-[#6B5A4E]" data-id="element-168">
                "El recurso que toda tejedora necesita."
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}